import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrincipalService } from '@core/auth/principal.service';
import { BaseComponent } from '@app/shared/components/base-component';

@Component({
    selector: 'app-home',
    templateUrl: './nav-automation.component.html',
    styleUrls: ['./nav-automation.component.css'],
    standalone: false
})
export class NavAutomationComponent extends BaseComponent implements OnInit, OnDestroy {
    data: any;

    constructor(
        protected principal: PrincipalService) {
            super();
        }

    ngOnInit() {}

    ngOnDestroy() {}
}